import "./App.css";
import MainNavbar from "./Components/Navbar/MainNavbar";
import { AllRoutes } from "./Components/AllRoutes/AllRoutes";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { toggleView } from "./Redux/action";
import LoginPage from "./pages/Login/LoginPage";
import { Link, useLocation, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { waitFor } from "@testing-library/react";
import { GenRoutes } from "./Components/AllRoutes/GenRoutes";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const wasSignedIn = localStorage.getItem("isLoggedIn") ? true : false; 
  const [isSignedIn, setSignedIn] = useState(wasSignedIn);
  
  const [isMobileView, setCurrentview] = useState(false);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  useEffect(() => {
    function handleWindowResize() {
      let screenwidth = getWindowSize().innerWidth;
      if (screenwidth < 1080 && !isMobileView) {
        setCurrentview(true);
      } else if (screenwidth > 1080 && !isMobileView ) {
        setCurrentview(false);
      }
      
    }
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    dispatch(toggleView(isMobileView));
  }, [isMobileView]);
  
  const signedin = (val) => {
    setSignedIn(!isSignedIn);
    console.log(val);
    if (val == "User"){
      navigate("/");
    } else{
      navigate("/dashboard");
    }
  }  
  
  return (
    <div className="App">
      {location.pathname.includes('/dashboard') ?<></> : <MainNavbar /> }
      { (isSignedIn) ? <AllRoutes /> : <GenRoutes signedin={signedin}/> }
      
    </div>
  );
}

export default App;
